import * as XLSX from 'xlsx';
import { applyColumnWidthsFromArrays } from './columnWidthCalculator';

interface IConsumptionByMonth {
  area_id: number;
  area_initials: string;
  supplement_classification_id: number;
  supplement_classification: string;
  supplements: {
    supplement_id: number;
    trade_name: string;
  }[];
  analyzed_period: number;
  replacement_frequency: number;
  months: {
    year_month: string;
    total_consumption: number;
  }[];
}

export const exportSupplementationConsumptionToExcel = (
  consumptionByMonth: IConsumptionByMonth[],
  mapMounths: Map<string, any>,
  startDate?: Date,
  endDate?: Date
) => {
  if (!consumptionByMonth || consumptionByMonth.length === 0) {
    throw new Error('Dados insuficientes para exportação');
  }

  const workbook = XLSX.utils.book_new();

  const rows: any[][] = [];

  const headerRow: any[] = ['Retiro', ...Array.from(mapMounths.keys()), 'Média Anual', 'Frequência de Reposição'];
  rows.push(headerRow);

  consumptionByMonth.forEach((area) => {
    const row: any[] = [area.area_initials];
    
    Array.from(mapMounths.keys()).forEach((month) => {
      const monthData = area.months.find(m => m.year_month === month);
      row.push(monthData?.total_consumption || 0);
    });
    
    const yearlyAvg = area.months.length > 0 
      ? parseFloat((area.months.reduce((acc, item) => acc + item.total_consumption, 0) / 12).toFixed(2))
      : 0;
    row.push(yearlyAvg);
    
    row.push(area.replacement_frequency);
    
    rows.push(row);
  });

  const totalRow: any[] = ['Somatória da Fazenda'];
  
  Array.from(mapMounths.values()).forEach((monthData: number[]) => {
    const total = monthData.reduce((acc, item) => acc + item, 0);
    totalRow.push(total);
  });
  
  const totalYearlyAvg = parseFloat(
    (Array.from(mapMounths.values()).flat().reduce((acc: number, item: number) => acc + item, 0) / 12).toFixed(2)
  );
  totalRow.push(totalYearlyAvg);
  
  totalRow.push('');
  
  rows.push(totalRow);

  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  applyColumnWidthsFromArrays(worksheet, rows);

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Consumo por Mês');

  const excelBuffer = XLSX.write(workbook, { 
    bookType: 'xlsx', 
    type: 'array' 
  });

  const blob = new Blob([excelBuffer], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  
  let filename = 'suplementacao-consumo';
  if (startDate && endDate) {
    const startStr = startDate.toISOString().split('T')[0];
    const endStr = endDate.toISOString().split('T')[0];
    filename = `suplementacao-consumo-${startStr}-${endStr}.xlsx`;
  } else {
    filename = `suplementacao-consumo-${new Date().toISOString().split('T')[0]}.xlsx`;
  }
  
  link.download = filename;
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};




